export default __webpack_public_path__ + "1334b42f8bc19df8acce1d9e45f931c9.svg";